import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';

import { isRecord } from '../../shared/utils/parse';
import { OrgApi } from '../api/org.api';
import type { OrgInfo } from '../models/org/org-info.model';
import type { ApiEnvelope } from './api-envelope';
import { apiPath, mapApiError, unwrapEnvelope } from './api-envelope';

@Injectable()
export class OrgHttpApi extends OrgApi {
  private readonly http = inject(HttpClient);

  override getOrgInfo(): Observable<OrgInfo> {
    return this.http
      .get<ApiEnvelope<unknown> | null>(apiPath('/api/delivery/settings/client'))
      .pipe(unwrapEnvelope<unknown>(), map(mapSettings), mapApiError());
  }
}

function mapSettings(raw: unknown): OrgInfo {
  const data = isRecord(raw) ? raw : {};
  return {
    deliveryFee: toAmount(data['deliveryPrice']),
    // Мусор в порогах = «не задано»: фича выключается, а не ломает корзину.
    freeDeliveryFrom: toAmount(data['freeFromAmount']) ?? 0,
    minOrderAmount: toAmount(data['minOrderAmount']) ?? 0,
  };
}

/** null — числа нет или оно мусорное. */
function toAmount(value: unknown): number | null {
  return typeof value === 'number' && Number.isFinite(value) && value >= 0 ? value : null;
}
